/* eslint-disable vue/one-component-per-file */
import Vue from 'vue';
import Vuex from 'vuex';
import VueCookies from 'vue-cookies';
import VScrollLock from 'v-scroll-lock';
import SlideUpDown from 'vue-slide-up-down'
// import VueIl8n from 'vue-i18n';

// Change vue delimiters, to use vue in twig and blade templates.
// This doesn't change the delimiters in .vue files
Vue.mixin({ delimiters: ['${', '}'] });


// ------------------------------------------------------------------------
// Vue Plugins
// ------------------------------------------------------------------------
Vue.use(VueCookies);
Vue.$cookies.config('30d');
Vue.use(VScrollLock);
Vue.component('slide-up-down', SlideUpDown);


// ------------------------------------------------------------------------
// Vue Multilanguage
// ------------------------------------------------------------------------
// Vue.use(VueIl8n);
// Vue.config.lang = 'en';
// Vue.locale('en', require('locales/en').default);

// ------------------------------------------------------------------------
// Vuex Store
// ------------------------------------------------------------------------
Vue.use(Vuex);
Vue.mixin({
    store: require('../store').default,
});


